/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Status from 'galax/server/building/status';


export default class extends Status
{
  install ()
  {
    // no-op.
  }


}
